import React from 'react'
import icon1 from '../assets/images/domain.png'
import icon2 from '../assets/images/learning.png'
import icon3 from '../assets/images/professional.png'
import icon4 from '../assets/images/advanced.png' 
function FeatureSection() {
return (
<div className="section-padding p-5 text-center">
   <div className="section-contant text-center">
      <div className="features-grid">
         <div className="feature">
            <div className="feature-icon">
               <img src={icon4} alt="Open API Icon" />
            </div>
            <div className="feature-title">
               <h3>Advance Technology Domain</h3>
            </div>
            <div className="feature-description">
               <p>
                  The quality of employees | workforce and their development through knowledge transfer and education are major factors in determining long-term profitability...
               </p>
               <a href="advanced-technology-domain"className="custom-button" >Read More</a>
            </div>
         </div>
         <div className="feature">
            <div className="feature-icon">
               <img src={icon2} alt="Simple Budgeting Icon" />
            </div>
            <div className="feature-title">
               <h3>Learning & Development Domain</h3>
            </div>
            <div className="feature-description">
               <p>The word 'Noetic' refers to "inner knowledge" or "intuitive consciousness", Often referred to as 'the science of what connects us', Noetic Science.... </p>
               <a href="noetc-science"className="custom-button" >Read More</a>
            </div>
         </div>
         <div className="feature">
            <div className="feature-icon">
               <img src={icon1} alt="Fast Onboarding Icon" />
            </div>
            <div className="feature-title">
               <h3>Domain Compliances & Governance</h3>
            </div>
            <div className="feature-description">
               <p>Business Houses are facing increasing pressure to improve their overall security posture.Volumes of regulations and stakeholder demands for transparency.... </p>
               <a href="domain-compliances-gov"className="custom-button" >Read More</a>
            </div>
         </div>
         <div className="feature">
            <div className="feature-icon">
               <img src={icon3} alt="Open API Icon" />
            </div>
            <div className="feature-title">
               <h3>Professional Service Domain</h3>
            </div>
            <div className="feature-description">
               <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Lorem ipsum sit amet, 
                  consectetuer adipiscing elit. 
               </p>
            <a href="professional-service-domain"className="custom-button" >Read More</a>
            </div>
         </div>
      </div>
   </div>
</div>
);
}
export default FeatureSection;